import React from "react";
import { Link } from "react-router-dom";

export default function GetMembershipComponent() {
  return (
    <>
      <style>
        {`
          .animated-btn {
            position: relative;
            animation: pulseGlow 2s infinite;
            transition: all 0.3s ease;
          }

          /* Hover still enhances it */
          .animated-btn:hover {
            transform: translateY(-3px) scale(1.05);
            box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);
          }

          /* Click feedback */
          .animated-btn:active {
            transform: scale(0.97);
          }

          /* Pulse + glow animation */
          @keyframes pulseGlow {
            0% {
              transform: scale(1);
              box-shadow: 0 0 0 rgba(0, 0, 0, 0.2);
            }
            50% {
              transform: scale(1.05);
              box-shadow: 0 8px 25px rgba(0, 0, 0, 0.25);
            }
            100% {
              transform: scale(1);
              box-shadow: 0 0 0 rgba(0, 0, 0, 0.2);
            }
          }

          /* Optional subtle shine loop */
          .animated-btn::after {
            content: "";
            position: absolute;
            top: 0;
            left: -75%;
            width: 50%;
            height: 100%;
            background: linear-gradient(
              120deg,
              transparent,
              rgba(255, 255, 255, 0.3),
              transparent
            );
            animation: shine 3s infinite;
          }

          @keyframes shine {
            0% {
              left: -75%;
            }
            100% {
              left: 125%;
            }
          }
        `}
      </style>

      <section className="pt-5" style={{ backgroundColor: "#f8f9fa" }}>
        <div className="container px-3">
          <div data-aos="fade-right">
            <div className="card rounded-3 border-vcg-muted">
              <div className="card-body p-0">
                <div className="row g-0">
                  {/* Left Side */}
                  <div className="col-lg-8 d-flex align-items-center p-4 p-lg-5">
                    <div>
                      <h3 className="fw-bold mb-4">
                        Keep the Legacy Alive - Join the Old Boys’ Association
                      </h3>

                      <p className="mb-0 text-secondary">
                        Join the Old Boys’ Association Vidyaloka College and
                        become part of a proud legacy. Register your membership
                        to stay connected, participate in events, and contribute
                        to the growth and development of our alma mater.
                      </p>
                    </div>
                  </div>

                  {/* Right Side */}
                  <div
                    className="
                col-lg-4
                d-flex
                justify-content-center
                align-items-lg-center
                px-4
                pt-3
                pb-4
                p-lg-5
              "
                  >
                    <Link
                      to="/membership/register"
                      className="btn btn-dark px-4 py-2 text-decoration-none animated-btn"
                    >
                      Get Membership
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
